import { createClient, processLock } from '@supabase/supabase-js';

let supabaseUrl = process.env.REACT_APP_SUPABASE_URL?.trim();
let supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY?.trim();

if (!supabaseUrl || !supabaseAnonKey) {
  // Fail soft: a module-scope throw here takes down the whole app with a blank
  // page (this module is in the import graph of nearly every route). Boot with
  // placeholder credentials instead — auth/data calls will fail visibly and
  // recoverably while the UI still renders.
  console.error(
    'Missing Supabase env vars. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY ' +
      'at build time (.env locally, or the hosting provider’s build environment variables).'
  );
  supabaseUrl = 'https://missing-env.invalid.supabase.co';
  supabaseAnonKey = 'missing-env';
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    flowType: 'pkce',
    detectSessionInUrl: true,
    persistSession: true,
    autoRefreshToken: true,
    lock: processLock,
  },
});
